import React, { Fragment } from 'react'

export default ({ trip: {acf: {bloc_share_facebook, classic_message_end_trip}}}) => (
  <div className="trip__share">
    <div className="container">
      <div className="trip__title" dangerouslySetInnerHTML={{__html: classic_message_end_trip}} />
      {bloc_share_facebook.enable_share && (
        <Fragment>
          <div className="trip__text" dangerouslySetInnerHTML={{__html: bloc_share_facebook.text}} />
          <a
            className="button button--outline button--round"
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(window.location.href)}`}
            target="_blank"
          >
            {bloc_share_facebook.label_share_button}
          </a>
        </Fragment>
      )}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Step/StepShare/StepShare.js